import React, { useContext } from "react";
import { CustomPicker } from "react-color";
import { ClientContext } from "../../../contexts/ClientContext";
import isColor from "is-color";
import Color from "color";
import { isvalidColorString } from "react-color/lib/helpers/color";
import { calcColorGradient } from "../../../helper/calcColorGradient";

const ColorInput = ({ rowLabel, pickedColor, label }) => {
  const { updateCurrentSet } = useContext(ClientContext);
  const { EditableInput } = require("react-color/lib/components/common");

  const onColorSelected = (value) => {
    // isValidColorString will catch the hsl values correctly that isColor for some reason cannot handle
    if (isvalidColorString(value[label]) || isColor(value[label].toLowerCase())) {
      // onColorChange({ color: rowLabel, pickedColor: Color(value[label].toLowerCase()).hex() });
      updateCurrentSet(
        {
          color: rowLabel,
          pickedColor: Color(value[label].toLowerCase()).hex(),
          gradientOptions: calcColorGradient(Color(value[label].toLowerCase()).hex()),
        },
        false
      );
    }
  };

  return (
    <div className="color-input">
      <EditableInput
        style={{ label: { fontSize: "1rem" }, input: { width: "12rem" } }}
        label={label}
        value={pickedColor}
        onChange={(e) => onColorSelected(e)}
      />
    </div>
  );
};

export default CustomPicker(ColorInput);
